import { Injectable, computed, signal } from '@angular/core';

interface AuthSession {
  username: string;
  token: string;
  loginAt: string;
}

const AUTH_STORAGE_KEY = 'armor-system-car.auth.session';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly sessionSignal = signal<AuthSession | null>(this.readSession());

  readonly session = this.sessionSignal.asReadonly();
  readonly isAuthenticated = computed(() => this.sessionSignal() !== null);
  readonly userName = computed(() => this.sessionSignal()?.username ?? 'Operador');

  login(username: string, _password: string): AuthSession {
    const normalizedUser = username.trim() || 'Operador';
    const session: AuthSession = {
      username: normalizedUser,
      token: `fake-token-${Date.now()}`,
      loginAt: new Date().toISOString(),
    };

    localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(session));
    this.sessionSignal.set(session);
    return session;
  }

  logout(): void {
    localStorage.removeItem(AUTH_STORAGE_KEY);
    this.sessionSignal.set(null);
  }

  private readSession(): AuthSession | null {
    const storedSession = localStorage.getItem(AUTH_STORAGE_KEY);
    if (!storedSession) {
      return null;
    }

    try {
      const parsed = JSON.parse(storedSession);
      if (
        parsed &&
        typeof parsed.username === 'string' &&
        typeof parsed.token === 'string' &&
        typeof parsed.loginAt === 'string'
      ) {
        return parsed;
      }
    } catch {
      // no-op
    }

    localStorage.removeItem(AUTH_STORAGE_KEY);
    return null;
  }
}
